import React, { useState, useEffect } from 'react';

const StatsSection = () => {
  const [experience, setExperience] = useState(0);
  const [employees, setEmployees] = useState(0);
  const [clients, setClients] = useState(0);

  const targetExperience = 7; // Years of experience
  const targetEmployees = 45; // Number of employees
  const targetClients = 1200; // Number of clients

  const duration = 2000; // Animation duration in ms

  useEffect(() => {
    const increment = (target, setter) => {
      const step = target / (duration / 50);
      let current = 0;
      const timer = setInterval(() => {
        current += step;
        if (current >= target) {
          setter(target);
          clearInterval(timer);
        } else {
          setter(Math.floor(current));
        }
      }, 50);
    };

    increment(targetExperience, setExperience);
    increment(targetEmployees, setEmployees);
    increment(targetClients, setClients);
  }, []);

  return (
    <section style={{ padding: '50px', textAlign: 'center', backgroundColor: '#0a043c',color:'#fff' }}>
      <h2>Our Stats</h2>
      <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '30px' }}>
        <div>
          <h3>{experience}+</h3>
          <p>Years of Experience</p>
        </div>
        <div>
          <h3>{employees}+</h3>
          <p>Employees</p>
        </div>
        <div>
          <h3>{clients}+</h3>
          <p>Clients</p>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;